import { reactive, computed } from '@vue/composition-api';

import { createProject } from '@/modules/teamplan/apis/projectsApis';

import { toastError, toastSuccess } from '@/helpers/toast';

const MAX_PROJECT_NAME_LENGTH = 30;

export const useCreateProjectModal = (
  props: { teamId: string },
  emit: (event: string, ...args: any[]) => void,
) => {
  const state = reactive({
    projectName: '',
  });

  const isValid = computed(() => {
    return (
      0 < state.projectName.length &&
      state.projectName.length <= MAX_PROJECT_NAME_LENGTH
    );
  });

  const submit = async () => {
    try {
      const {
        data: { id: projectId },
      } = await createProject(props.teamId, state.projectName);
      toastSuccess('プロジェクトを作成しました');

      emit('project-created', projectId, state.projectName);
      emit('input', false);

      state.projectName = '';
    } catch {
      toastError('プロジェクト作成時にエラーが発生しました');
    }
  };

  return {
    state,
    isValid,
    submit,
    MAX_PROJECT_NAME_LENGTH,
  };
};
